function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/* --------------------------------------------
Import modules
-------------------------------------------- */

import SimpleSelectorController from 'simple-selector';
import FiltersController from '@meteora-digital/filters';
document.addEventListener('DOMContentLoaded', function () {
  /* --------------------------------------------
  Gate
  -------------------------------------------- */

  if (!document.querySelector('.js-projects')) return;

  /* --------------------------------------------
  Elements
  -------------------------------------------- */

  // The page
  var projects = document.querySelector('.js-projects');
  // The projects list
  var list = projects.querySelector('.js-projects__list');
  // The filters form
  var form = projects.querySelector('form');
  // The reset button
  var reset = projects.querySelector('.js-projects__reset');
  // The form selects
  var selects = _toConsumableArray(form.querySelectorAll('select'));
  // The load more button
  var loadmore = null;
  // Some timeouts
  var timeouts = {};

  /* --------------------------------------------
  Classes
  -------------------------------------------- */

  // Used to handle load more
  var Load = new FiltersController(form.action);
  // Used to handle filtering / content replacement
  var Filters = new FiltersController(form.action);

  /* --------------------------------------------
  Methods
  -------------------------------------------- */

  // Method to call when the filters are changed
  var onChange = function onChange() {
    // Clear the load more
    Load.clear();
    // Clear the filters
    Filters.clear();

    // Clear the timeout
    clearTimeout(timeouts.filter);

    // Loop through the selects and add their values to the filters value
    selects.forEach(function (select) {
      if (select.value !== '') {
        // Update the load more
        Load.add('tags', select.value);
        // Update the filters
        Filters.add('tags', select.value);
        // Add an active class to the select
        select.SimpleSelector.select.classList.add('active');
      } else {
        // Remove the active class from the select
        select.SimpleSelector.select.classList.remove('active');
      }
    });

    // If we have no filters, set the reset input to 'checked'
    reset.checked = !Object.keys(Filters.value).length;

    // Add the loading class
    list.classList.add('loading');

    // Set a timeout to apply the filters
    timeouts.filter = setTimeout(function () {
      // Apply the filters
      Filters.apply();
    });
  };

  // Method to call when the load more button is clicked
  var onLoadMore = function onLoadMore() {
    // Clear the timeout
    clearTimeout(timeouts.loadmore);

    // Add the loading class
    list.classList.add('loading');

    // Set a timeout to load more
    timeouts.loadmore = setTimeout(function () {
      // Load more
      Load.apply();
    });
  };
  var onComplete = function onComplete() {
    setTimeout(function () {
      window.equalize();
      // Remove the loading class
      list.classList.remove('loading');

      // Initialise the page
      init();
    }, 300);
  };

  // Method to initialise certain parts of the page
  var init = function init() {
    // Find the load more button in the list if there is one
    loadmore = list.querySelector('.js-projects__loadmore');

    // If we have a load more button, add an event listener
    if (loadmore) {
      var page = loadmore.value.split('=')[1];
      loadmore.addEventListener('click', function (e) {
        e.preventDefault();

        // Set the load more page to the value of this button
        Load.set('start', page);
        onLoadMore();
      });
    }
  };

  /* --------------------------------------------
  Event Listeners
  -------------------------------------------- */

  // When we have successfully loaded more
  Load.on('success', function (r) {
    // If we have a load more button, remove it
    if (loadmore) loadmore.parentNode.remove();

    // Append the new projects to the list
    list.insertAdjacentHTML('beforeend', r);
    onComplete();
  });

  // When we have successfully loaded the projects
  Filters.on('success', function (r) {
    // Set the innerHTML of the list
    list.innerHTML = r;
    onComplete();
  });

  /* --------------------------------------------
  Document setup
  -------------------------------------------- */

  reset.addEventListener('change', function (e) {
    e.preventDefault();
    // Reset the form
    form.reset();

    // Reset the simple selectors
    selects.forEach(function (select) {
      return select.SimpleSelector.update();
    });

    // Trigger the change event
    onChange();
  });
  selects.forEach(function (select) {
    var cache = select.value;
    // Create a new simple selector
    select.SimpleSelector = new SimpleSelectorController(select);
    // Listen for changes
    select.addEventListener('change', function () {
      // If the value has changed, trigger the change event
      if (cache !== select.value) {
        onChange();
        cache = select.value;
      }
    });
  });

  // Initialise the page
  init();
});